@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Divider {
  &.Horizontal {
    hr {
      margin: 0;
      width: 100%;
      height: 1px;
      border-width: 0;

      &.themeDefault {
        background-color: $theme-color-divider;
      }

      &.green {
        background-color: $color-secondary-green;
      }

      &.purple {
        background-color: $color-primary-purple;
      }
    }
  }

  &.Vertical {
    hr {
      margin: 0;
      height: 100%;
      width: 1px;
      border-width: 0;
      background-color: $theme-color-divider;
      padding: 0;
    }
  }

  &.CenterAlign {
    display: grid;
    align-items: center;
    height: 100%;
  }
}
